import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from "../../../../../actions/fillCombo_action";
import {
  serviceTypeId,
  toastError,
  toastSuccess,
  exhibitionId,
  BASE_URL,
  areaActionId,
} from "../../../../../utils/constants";
import "react-datepicker/dist/react-datepicker.css";
import Pagination from "../../../../../utils/pagination";
import AdminDrawer from "../../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../../common_components/header_with_logo";
import {
  getAdditionalFurnitureMasterList_action,
  insertUpdateAdditionalFurnitureMaster_action,
  deleteAdditionalFurnitureMaster_action,
  deleteInsertShellScheme_action,
  getShellSchemeList_action,
} from "../../../../../actions/admin_module_action/master_action/manual_form_master_action/additional_furniture_master_action";

const styles = {
  width: "100%",
};

class AdditionalFurnitureMaster extends Component {
  constructor(props) {
    super(props);
    const userRoleID = JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID;
    let defaultStatus = "1";

    this.state = {
      isLoading: false,
      additionalFurnitureList: [],
      currentPage: 1,
      ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
      exhibitionList: [],
      WorkOrderNumber: "",
      PersonName: "",
      ServiceID: "",
      serviceTypeList: [],
      Status: defaultStatus,
      EmailID: "",
      VendorPlanStatusList: [],
      additionalFurnitureList: [],
      isOpen: false,
      sortField: "",
      sortOrder: "",
      showEditModal: false,
      editData: null,
      editItem: "",
      editDimension: "",
      editRateINR: "",
      editRateUSD: "",
      editTotalQuantity: "",
      editPicture: "",
      editPictureFileName: "",
      editPictureType: "",
      editNewPicture: null,
      showAddModal: false,
      addItem: "",
      addDimension: "",
      addPicture: null,
      addPictureFileName: "",
      addPictureType: "",
      addRateINR: "",
      addRateUSD: "",
      addTotalQty: "",
      showConfigModal: false,
      configTableData: [],
      showDeleteModal: false,
      deleteData: null,
    };
    this.updateItem = this.updateItem.bind(this);
  }

  componentDidMount() {
    this.getFillList(exhibitionId, "", "", "", "", "");
    this.getAdditionalFurnitureList();
  }

  getAdditionalFurnitureList() {
    const { Item, Status } = this.state;

    this.setState({ isLoading: true });
    try {
      this.props
        .getAdditionalFurnitureMasterList_action(Item, Status)
        .then((data) => {
          if (data.error != 1) {
            const flattenedData = Array.isArray(data.data?.[0])
              ? data.data[0]
              : data.data || [];
            this.setState({
              additionalFurnitureList: flattenedData,
            });
          } else {
            toastError(data.msg);
          }
          this.setState({ isLoading: false });
        })
        .catch((err) => {
          console.log(err);
        });
    } catch {
      toastError("Something went wrong!");
      this.setState({ isLoading: false });
    }
  }

  updateItem(item) {
    const { additionalFurnitureList } = this.state;
    this.setState({ currentPage: item });
    const recordsPerPage = 10;
    const indexOfLastRecord = item * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = additionalFurnitureList.slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
    const nPages = Math.ceil(additionalFurnitureList.length / recordsPerPage);
  }

  // get fill List dropdown
  getFillList(
    actionID,
    exhibitionID,
    moduleID,
    keyValue,
    value,
    exhRegistrationID
  ) {
    const { } = this.state;
    if (actionID === exhibitionId) {
      this.setState({ isLoading: true });
    }
    this.props
      .fill_action(
        actionID,
        exhibitionID,
        moduleID,
        keyValue,
        value,
        exhRegistrationID
      )
      .then((data) => {
        if (data.error != 1) {
          if (actionID === exhibitionId) {
            this.setState({
              exhibitionList: data.data,
              isLoading: false,
            });
          } else if (actionID === areaActionId) {
            this.setState({
              configTableData: data.data || [],
            });
          }
        } else {
          if (actionID === exhibitionId) {
            this.setState({ isLoading: false });
          }
          toastError(data.msg);
        }
      })
      .catch((e) => {
        console.log(e);
        if (actionID === exhibitionId) {
          this.setState({ isLoading: false });
        }
      });
  }

  clearValue() {
    this.setState(
      {
        ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
        WorkOrderNumber: "",
        PersonName: "",
        ServiceID: "",
        EmailID: "",
        Status: "1",
        currentPage: 1,
      },
      () => {
        this.getAdditionalFurnitureList();
      }
    );
  }

  formatDate = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return null;

    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = date.getUTCFullYear();
    const hours = String(date.getUTCHours()).padStart(2, "0");
    const minutes = String(date.getUTCMinutes()).padStart(2, "0");
    const seconds = String(date.getUTCSeconds()).padStart(2, "0");

    return `${day}-${month}-${year}, ${hours}:${minutes}:${seconds}`;
  };

  openEditModal = (data) => {
    this.setState({
      showEditModal: true,
      editData: data,
      editItem: data.Items || data.ItemName || "",
      editDimension: data.Dimension || data.Dimensions || "",
      editRateINR: data.INRRate || data.RateINR || "",
      editRateUSD: data.USDRate || data.RateUSD || "",
      editTotalQuantity: data.TotalQuantity || "",
      editPicture: data.Picture || "",
      editPictureFileName: "",
      editPictureType: "",
      editNewPicture: null,
    });
  };

  closeEditModal = () => {
    this.setState({
      showEditModal: false,
      editData: null,
      editItem: "",
      editDimension: "",
      editRateINR: "",
      editRateUSD: "",
      editTotalQuantity: "",
      editPicture: "",
      editPictureFileName: "",
      editPictureType: "",
      editNewPicture: null,
    });
  };

  handleRemoveEditPicture = () => {
    this.setState({
      editPicture: "",
      editNewPicture: null,
      editPictureFileName: "",
      editPictureType: "",
    });
  };

  handleEditPictureChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const validTypes = [
        "image/jpeg",
        "image/png",
        "image/jpg",
        "application/pdf",
      ];
      if (validTypes.includes(file.type)) {
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64String = reader.result.split(",")[1];
          const fileExtension = file.name.split(".").pop();
          this.setState({
            editNewPicture: base64String,
            editPictureFileName: file.name,
            editPictureType: fileExtension,
            editPicture: "",
          });
        };
        reader.readAsDataURL(file);
      } else {
        toastError("Please upload only image (JPG, PNG) or PDF files");
      }
    }
  };

  handleSaveEdit = () => {
    const {
      editData,
      editItem,
      editDimension,
      editNewPicture,
      editPictureType,
      editRateINR,
      editRateUSD,
      editTotalQuantity,
    } = this.state;

    const AdditionalFurnituremasterList = [
      {
        MstAdditionalFurnitureID: editData.MstAdditionalFurnitureID,
        Items: editItem,
        Dimension: editDimension,
        img: editNewPicture || "",
        imgType: editPictureType || "",
        INRRate: editRateINR,
        USDRate: editRateUSD,
        TotalQuantity: editTotalQuantity,
      },
    ];

    this.setState({ isLoading: true });
    this.props
      .insertUpdateAdditionalFurnitureMaster_action(
        AdditionalFurnituremasterList
      )
      .then((data) => {
        if (data.error != 1) {
          toastSuccess(data.msg || "Furniture updated successfully!");
          this.closeEditModal();
          this.getAdditionalFurnitureList();
        } else {
          toastError(data.msg);
        }
        this.setState({ isLoading: false });
      })
      .catch((err) => {
        console.log(err);
        toastError("Something went wrong!");
        this.setState({ isLoading: false });
      });
  };

  openDeleteModal = (data) => {
    this.setState({ showDeleteModal: true, deleteData: data });
  };

  closeDeleteModal = () => {
    this.setState({ showDeleteModal: false, deleteData: null });
  };

  confirmDelete = () => {
    const { deleteData } = this.state;
    this.setState({ isLoading: true, showDeleteModal: false });
    this.props
      .deleteAdditionalFurnitureMaster_action(
        deleteData.MstAdditionalFurnitureID
      )
      .then((res) => {
        if (res.error != 1) {
          toastSuccess(res.msg || "Record deleted successfully!");
          this.getAdditionalFurnitureList();
        } else {
          toastError(res.msg);
        }
        this.setState({ isLoading: false, deleteData: null });
      })
      .catch((err) => {
        console.log(err);
        toastError("Something went wrong!");
        this.setState({ isLoading: false, deleteData: null });
      });
  };

  openAddModal = () => {
    this.setState({ showAddModal: true });
  };

  closeAddModal = () => {
    this.setState({
      showAddModal: false,
      addItem: "",
      addDimension: "",
      addPicture: null,
      addPictureFileName: "",
      addPictureType: "",
      addRateINR: "",
      addRateUSD: "",
      addTotalQty: "",
    });
  };

  handleAddPictureChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const validTypes = [
        "image/jpeg",
        "image/png",
        "image/jpg",
        "application/pdf",
      ];
      if (validTypes.includes(file.type)) {
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64String = reader.result.split(",")[1];
          const fileExtension = file.name.split(".").pop();
          this.setState({
            addPicture: base64String,
            addPictureFileName: file.name,
            addPictureType: fileExtension,
          });
        };
        reader.readAsDataURL(file);
      } else {
        toastError("Please upload only image (JPG, PNG) or PDF files");
      }
    }
  };

  openConfigModal = () => {
    this.setState({ showConfigModal: true, isLoading: true });

    Promise.all([
      this.props.fill_action(areaActionId, sessionStorage.getItem("sessionExhibitionID"), "1", "", "2", ""),
      this.props.getShellSchemeList_action()
    ])
      .then(([fillData, shellData]) => {
        const exhibitionData = shellData.data?.[0] || [];
        const stallAreaData = fillData.data || [];

        const distinctAreas = [...new Set([
          ...exhibitionData.map(item => item.AreaInSQM),
          ...stallAreaData.map(item => item.StallArea)
        ])].sort((a, b) => a - b);

        const configTableData = distinctAreas.map(area => {
          const exhibitionItem = exhibitionData.find(item => item.AreaInSQM === area) || {};
          return {
            StallArea: area,
            DeskTable: exhibitionItem.DeskTable || "",
            RoundTable: exhibitionItem.RoundTable || "",
            Chairs: exhibitionItem.Chairs || "",
            SpotLights: exhibitionItem.SpotLights || "",
            PlugPoints: exhibitionItem.PlugPoints || "",
            DustBins: exhibitionItem.DustBins || "",
            SinglePhasePower: exhibitionItem.SinglePhasePower || ""
          };
        });

        this.setState({ configTableData, isLoading: false });
      })
      .catch((err) => {
        console.log(err);
        toastError("Something went wrong!");
        this.setState({ isLoading: false });
      });
  };

  closeConfigModal = () => {
    this.setState({ showConfigModal: false });
  };

  handleConfigInputChange = (index, field, value) => {
    const { configTableData } = this.state;
    const updatedData = [...configTableData];
    updatedData[index] = { ...updatedData[index], [field]: value };
    this.setState({ configTableData: updatedData });
  };

  handleSaveConfig = () => {
    const { configTableData } = this.state;
    const ConfigFurnitureDetailList = configTableData.map((item) => ({
      AreaInSQM: item.StallArea || 0,
      DeskTable: item.DeskTable || 0,
      RoundTable: item.RoundTable || 0,
      Chairs: item.Chairs || 0,
      SpotLights: item.SpotLights || 0,
      PlugPoints: item.PlugPoints || 0,
      DustBins: item.DustBins || 0,
      SinglePhasePower: item.SinglePhasePower || 0,
    }));

    this.setState({ isLoading: true });
    this.props
      .deleteInsertShellScheme_action(ConfigFurnitureDetailList)
      .then((data) => {
        if (data.error != 1) {
          toastSuccess(data.msg || "Configuration saved successfully!");
          this.closeConfigModal();
        } else {
          toastError(data.msg);
        }
        this.setState({ isLoading: false });
      })
      .catch((err) => {
        console.log(err);
        toastError("Something went wrong!");
        this.setState({ isLoading: false });
      });
  };

  handleSaveAdd = () => {
    const {
      addItem,
      addDimension,
      addPicture,
      addPictureType,
      addRateINR,
      addRateUSD,
      addTotalQty,
      ExhibitionID,
    } = this.state;

    const AdditionalFurnituremasterList = [
      {
        Items: addItem,
        Dimension: addDimension,
        img: addPicture || "",
        imgType: addPictureType || "",
        INRRate: addRateINR,
        USDRate: addRateUSD,
        TotalQuantity: addTotalQty,
      },
    ];

    this.setState({ isLoading: true });
    this.props
      .insertUpdateAdditionalFurnitureMaster_action(
        AdditionalFurnituremasterList
      )
      .then((data) => {
        if (data.error != 1) {
          toastSuccess(data.msg || "Furniture added successfully!");
          this.closeAddModal();
          this.getAdditionalFurnitureList();
        } else {
          toastError(data.msg);
        }
        this.setState({ isLoading: false });
      })
      .catch((err) => {
        console.log(err);
        toastError("Something went wrong!");
        this.setState({ isLoading: false });
      });
  };

  render() {
    const {
      isLoading,
      ExhibitionID,
      currentPage,
      exhibitionList,
      Status,
      additionalFurnitureList,
    } = this.state;

    // Create vendorServiceListArr exactly like vendor_exhibition_list
    const recordsPerPage = 10;
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = additionalFurnitureList.slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
    const nPages = Math.ceil(additionalFurnitureList.length / recordsPerPage);

    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        <HeaderWithLogo />
        <>
          <div className="with-dr-container">
            <div className="row">
              <div className="breadcrumb-scroll-fixed">
                <h6 className="mb-0 px-3 py-2 text-white">
                  Additional Furniture Master
                </h6>
              </div>
            </div>

            <div className="app-content com-height" >
              <AdminDrawer />
              <div className="admin-top-space p-2">
                <div className="row m-0" >
                  <div className="col-md-3">
                    <label>Exhibition</label>
                    <select
                      className="form-control"
                      id="roledb"
                      value={ExhibitionID}
                      onChange={(e) =>
                        this.setState({ ExhibitionID: e.target.value })
                      }
                    >
                      <option>Select</option>
                      {exhibitionList.length > 0 &&
                        exhibitionList.map((data) => (
                          <option
                            key={data.ExhibitionID}
                            value={data.ExhibitionID}
                          >
                            {data.ExhibitionName}
                          </option>
                        ))}
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label>Item</label>
                    <input
                      className="form-control"
                      id="roledb"
                      // value={Item}
                      onChange={(e) => this.setState({ Item: e.target.value })}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Status</label>
                    <select
                      className="form-control"
                      id="roledb"
                      value={Status}
                      onChange={(e) => this.setState({ Status: e.target.value })}
                    >
                      <option value="">Select</option>
                      <option value="1">Active</option>
                      <option value="0">Inactive</option>
                    </select>
                  </div>
                  <div className="col-md-3 mt-2 text-end">
                    <label></label>
                    <div className="mb-1">

                      <button
                        type="button"
                        className="btn btn-aqua"
                        onClick={(e) => this.getAdditionalFurnitureList()}
                      >
                        Search
                      </button>

                      <button
                        type="button"
                        className="btn btn-gray ms-2"
                        onClick={(e) => this.clearValue()}
                      >
                        Clear
                      </button>
                    </div>
                  </div>
                  <div className="col-md-12 px-0">
                    <div className="d-flex justify-content-end mt-3">
                      <div className="d-flex gap-2 mb-1">

                        <button
                          type="button"
                          className="btn btn-aqua"
                          onClick={this.openAddModal}
                        >
                          Add
                        </button>

                        <button
                          type="button"
                          className="btn btn-aqua"
                          onClick={this.openConfigModal}
                        >
                          Basic Config
                        </button>

                      </div>
                    </div>
                  </div>

                  {/* </div> */}
                </div>
              </div>
              <div className="row m-0 mx-2">
                <div class="table-responsive px-0 sticky-table-wrapper service-list-grid mx-2">
                  <table class="table sticky-table text-nowrap table-bordered mb-0">
                    <thead class="table-light">

                      <tr>
                        <th>
                          <div className="icons-shorting">Furniture Description</div>
                        </th>
                        <th>
                          <div className="icons-shorting">Item Code</div>
                        </th>
                        <th>
                          <div className="icons-shorting">Picture</div>
                        </th>
                        <th colSpan={2} className="text-center">
                          Rate
                        </th>
                        <th>
                          <div className="icons-shorting">Total Quantity</div>
                        </th>
                        <th className="text-center">Status</th>
                        <th className="text-center">Action</th>
                      </tr>
                      <tr>
                        <th colSpan={3} />
                        <th className="text-center">Price (INR)</th>
                        <th className="text-center">Price (USD)</th>
                        <th colSpan={3} />
                      </tr>
                    </thead>
                    <tbody>
                      {currentRecords.length > 0 && currentRecords != null ? (
                        currentRecords.map((data, i) => {
                          const actualIndex = indexOfFirstRecord + i;
                          return (
                            <tr key={i}>
                              <td>{data.Items || data.ItemName || "-"}</td>
                              <td>{data.Dimension || data.Dimensions || "-"}</td>
                              <td>
                                {data.Picture ? (
                                  data.Picture.toLowerCase().endsWith(".pdf") ? (
                                    <a
                                      className="overflow-membership m-0"
                                      target="_blank"
                                      href={
                                        BASE_URL.split("/api")[0] + data.Picture
                                      }
                                      style={{ cursor: "pointer" }}
                                      rel="noopener noreferrer"
                                    >
                                      <i className="fa fa-eye grid-icon" />
                                    </a>
                                  ) : (
                                    <img
                                      src={
                                        BASE_URL.split("/api")[0] + data.Picture
                                      }
                                      alt="Item"
                                      style={{
                                        width: "50px",
                                        height: "50px",
                                        objectFit: "cover",
                                      }}
                                    />
                                  )
                                ) : (
                                  "-"
                                )}
                              </td>
                              <td className="text-center">
                                {data.INRRate || "-"}
                              </td>
                              <td className="text-center">
                                {data.USDRate || "-"}
                              </td>
                              <td>
                                {data.TotalQuantity || data.TotalQuantity || "-"}
                              </td>
                              <td>
                                {data.Status === true || data.Status === 1
                                  ? "Active"
                                  : "Inactive"}
                              </td>
                              <td className="text-center act-col">
                                <a>
                                  <i
                                    className="fa fa-pencil-square-o grid-icon mx-1"
                                    title="Edit"
                                    onClick={() => this.openEditModal(data)}
                                    style={{ cursor: "pointer" }}
                                  />{" "}
                                  |{" "}
                                  <i
                                    className="fa fa-trash text-danger mx-1"
                                    title="Delete"
                                    onClick={() => this.openDeleteModal(data)}
                                    style={{ cursor: "pointer" }}
                                  />
                                </a>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={10} className="text-center">
                            Record not found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>

                  <div className="mt-2 float-left trp">
                    {additionalFurnitureList.length > 0 ? (
                      <Pagination
                        nPages={nPages}
                        currentPage={currentPage}
                        setCurrentPage={this.updateItem}
                      />
                    ) : (
                      <></>
                    )}
                    <div className="table-record-pages ">
                      <p>{`${currentPage} of ${nPages} pages`}</p>
                    </div>
                  </div>
                </div>
              </div>
              {this.state.showEditModal && (
                <div
                  className="modal"
                  style={{
                    display: "block",
                    backgroundColor: "rgba(0,0,0,0.5)",
                  }}
                >
                  <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Edit Furniture Item</h5>
                        {/* <button
                          type="button"
                          className="close"
                          onClick={this.closeEditModal}
                        >
                          <span>&times;</span>
                        </button> */}
                      </div>
                      <div className="modal-body">
                        <div className="row">
                          <div className="col-md-6">
                            <label>Item</label>
                            <input
                              type="text"
                              className="form-control"
                              value={this.state.editItem}
                              onChange={(e) =>
                                this.setState({ editItem: e.target.value })
                              }
                            />
                          </div>
                          <div className="col-md-6">
                            <label>Dimensions</label>
                            <input
                              type="text"
                              className="form-control"
                              value={this.state.editDimension}
                              onChange={(e) =>
                                this.setState({ editDimension: e.target.value })
                              }
                            />
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-md-6">
                            <label>Picture</label>
                            <div>
                              {this.state.editPicture ? (
                                <div className="text-left">
                                  {this.state.editPicture
                                    .toLowerCase()
                                    .endsWith(".pdf") ? (
                                    <a
                                      className="btn btn-sm btn-aqua"
                                      target="_blank"
                                      href={
                                        BASE_URL.split("/api")[0] +
                                        this.state.editPicture
                                      }
                                      rel="noopener noreferrer"
                                    >
                                      <i className="fa fa-eye" /> View PDF
                                    </a>
                                  ) : (
                                    <a
                                      target="_blank"
                                      href={
                                        BASE_URL.split("/api")[0] +
                                        this.state.editPicture
                                      }
                                      rel="noopener noreferrer"
                                    >
                                      <img
                                        src={
                                          BASE_URL.split("/api")[0] +
                                          this.state.editPicture
                                        }
                                        alt="Item"
                                        style={{
                                         
                                          height: "100px",
                                          objectFit: "cover",
                                        }}
                                      />
                                    </a>
                                  )}
                                  <br></br>
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-danger mt-2"
                                    onClick={this.handleRemoveEditPicture}
                                    title="Remove file"
                                  >
                                    <i className="fa fa-trash" /> Remove
                                  </button>
                                </div>
                              ) : (
                                <span className="text-muted">
                                  No picture available
                                </span>
                              )}
                            </div>
                            <div className="mt-2">
                              <input
                                type="file"
                                className="form-control"
                                accept=".jpg,.jpeg,.png,.pdf"
                                onChange={this.handleEditPictureChange}
                              />
                              {this.state.editPictureFileName && (
                                <small className="text-muted">
                                  Selected: {this.state.editPictureFileName}
                                </small>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <label>Rate INR</label>
                            <input
                              type="number"
                              className="form-control"
                              value={this.state.editRateINR}
                              onChange={(e) =>
                                this.setState({ editRateINR: e.target.value })
                              }
                            />
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-md-6">
                            <label>Rate USD</label>
                            <input
                              type="number"
                              className="form-control"
                              value={this.state.editRateUSD}
                              onChange={(e) =>
                                this.setState({ editRateUSD: e.target.value })
                              }
                            />
                          </div>
                          <div className="col-md-6">
                            <label>Total Quantity</label>
                            <input
                              type="number"
                              className="form-control"
                              value={this.state.editTotalQuantity}
                              onChange={(e) =>
                                this.setState({
                                  editTotalQuantity: e.target.value,
                                })
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-gray"
                          onClick={this.closeEditModal}
                        >
                          Back
                        </button>
                        <button
                          type="button"
                          className="btn btn-aqua"
                          onClick={this.handleSaveEdit}
                        >
                          Save Changes
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {this.state.showAddModal && (
                <div
                  className="modal"
                  style={{
                    display: "block",
                    backgroundColor: "rgba(0,0,0,0.5)",
                  }}
                >
                  <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Add Furniture Item</h5>
                        {/* <button
                          type="button"
                          className="close"
                          onClick={this.closeAddModal}
                        >
                          <span>&times;</span>
                        </button> */}
                      </div>
                      <div className="modal-body">
                        <div className="row">
                          <div className="col-md-6">
                            <label>Furniture Description</label>
                            <input
                              type="text"
                              className="form-control"
                              value={this.state.addItem}
                              onChange={(e) =>
                                this.setState({ addItem: e.target.value })
                              }
                            />
                          </div>
                          <div className="col-md-6">
                            <label>Item Code</label>
                            <input
                              type="text"
                              className="form-control"
                              value={this.state.addDimension}
                              onChange={(e) =>
                                this.setState({ addDimension: e.target.value })
                              }
                            />
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-md-6">
                            <label>Picture (Image/PDF only)</label>
                            <input
                              type="file"
                              className="form-control"
                              accept=".jpg,.jpeg,.png,.pdf"
                              onChange={this.handleAddPictureChange}
                            />
                            {this.state.addPictureFileName && (
                              <small className="text-muted">
                                Selected: {this.state.addPictureFileName}
                              </small>
                            )}
                          </div>
                          <div className="col-md-6">
                            <label>Rate INR</label>
                            <input
                              type="number"
                              className="form-control"
                              value={this.state.addRateINR}
                              onChange={(e) =>
                                this.setState({ addRateINR: e.target.value })
                              }
                            />
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-md-6">
                            <label>Rate USD</label>
                            <input
                              type="number"
                              className="form-control"
                              value={this.state.addRateUSD}
                              onChange={(e) =>
                                this.setState({ addRateUSD: e.target.value })
                              }
                            />
                          </div>
                          <div className="col-md-6">
                            <label>Total Qty</label>
                            <input
                              type="number"
                              className="form-control"
                              value={this.state.addTotalQty}
                              onChange={(e) =>
                                this.setState({ addTotalQty: e.target.value })
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-gray"
                          onClick={this.closeAddModal}
                        >
                          Close
                        </button>
                        <button
                          type="button"
                          className="btn btn-aqua"
                          onClick={this.handleSaveAdd}
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {this.state.showDeleteModal && (
                <div
                  className="modal"
                  style={{
                    display: "block",
                    backgroundColor: "rgba(0,0,0,0.5)",
                  }}
                >
                  <div className="modal-dialog">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Confirm Delete</h5>
                        <button
                          type="button"
                          className="close"
                          onClick={this.closeDeleteModal}
                        >
                          <span>&times;</span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <p>Are you sure you want to delete this item?</p>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-gray"
                          onClick={this.closeDeleteModal}
                        >
                          No
                        </button>
                        <button
                          type="button"
                          className="btn btn-danger"
                          onClick={this.confirmDelete}
                        >
                          Yes
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {this.state.showConfigModal && (
                <div
                  className="modal"
                  style={{
                    display: "block",
                    backgroundColor: "rgba(0,0,0,0.5)",
                  }}
                >
                  <div className="modal-dialog modal-xl">
                    <div
                      className="modal-content"
                      style={{
                        maxHeight: "90vh",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <div className="modal-header">
                        <h5 className="modal-title">Config Basic Furniture</h5>
                        {/* <button
                          type="button"
                          className="close"
                          onClick={this.closeConfigModal}
                        >
                          <span>&times;</span>
                        </button> */}
                      </div>
                      <div
                        className="modal-body"
                        style={{ overflowY: "auto", flex: "1" }}
                      >
                        <div class="table-responsive px-1 sticky-table-wrapper service-list-grid">
                          <table class="table sticky-table text-nowrap table-bordered border-bottom border-2 mb-0">
                            <thead class="table-light">

                              <tr>
                                <th>Area(sqm)</th>
                                <th>Desk</th>
                                <th>Round Table</th>
                                <th>Chairs</th>
                                <th>Spotlights</th>
                                <th>Plugpoints</th>
                                <th>Dustbins</th>
                                <th>Single Phase Power</th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.configTableData.length > 0 ? (
                                this.state.configTableData.map(
                                  (item, index) => (
                                    <tr key={index}>
                                      <td>{item.StallArea}</td>
                                      <td>
                                        <input
                                          type="number"
                                          className="form-control"
                                          value={item.DeskTable || ""}
                                          onChange={(e) =>
                                            this.handleConfigInputChange(
                                              index,
                                              "DeskTable",
                                              e.target.value
                                            )
                                          }
                                        />
                                      </td>
                                      <td>
                                        <input
                                          type="number"
                                          className="form-control"
                                          value={item.RoundTable || ""}
                                          onChange={(e) =>
                                            this.handleConfigInputChange(
                                              index,
                                              "RoundTable",
                                              e.target.value
                                            )
                                          }
                                        />
                                      </td>
                                      <td>
                                        <input
                                          type="number"
                                          className="form-control"
                                          value={item.Chairs || ""}
                                          onChange={(e) =>
                                            this.handleConfigInputChange(
                                              index,
                                              "Chairs",
                                              e.target.value
                                            )
                                          }
                                        />
                                      </td>
                                      <td>
                                        <input
                                          type="number"
                                          className="form-control"
                                          value={item.SpotLights || ""}
                                          onChange={(e) =>
                                            this.handleConfigInputChange(
                                              index,
                                              "SpotLights",
                                              e.target.value
                                            )
                                          }
                                        />
                                      </td>
                                      <td>
                                        <input
                                          type="number"
                                          className="form-control"
                                          value={item.PlugPoints || ""}
                                          onChange={(e) =>
                                            this.handleConfigInputChange(
                                              index,
                                              "PlugPoints",
                                              e.target.value
                                            )
                                          }
                                        />
                                      </td>
                                      <td>
                                        <input
                                          type="number"
                                          className="form-control"
                                          value={item.DustBins || ""}
                                          onChange={(e) =>
                                            this.handleConfigInputChange(
                                              index,
                                              "DustBins",
                                              e.target.value
                                            )
                                          }
                                        />
                                      </td>
                                      <td>
                                        <input
                                          type="number"
                                          className="form-control"
                                          value={item.SinglePhasePower || ""}
                                          onChange={(e) =>
                                            this.handleConfigInputChange(
                                              index,
                                              "SinglePhasePower",
                                              e.target.value
                                            )
                                          }
                                        />
                                      </td>
                                    </tr>
                                  )
                                )
                              ) : (
                                <tr>
                                  <td colSpan="8" className="text-center">
                                    No data available
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className="modal-footer" style={{ flexShrink: 0 }}>
                        <button
                          type="button"
                          className="btn btn-gray"
                          onClick={this.closeConfigModal}
                        >
                          Close
                        </button>
                        <button
                          type="button"
                          className="btn btn-aqua"
                          onClick={this.handleSaveConfig}
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <>
                <div class="footer-sec ">
                  <div class="sdsd">
                    <strong>Ownership:</strong> All content, formats and images
                    used on this site are owned or licensed by India ITME
                    Society. You may not copy, reproduce, distribute, publish,
                    display, perform, modify, create derivative works, transmit,
                    or in any other way exploit any part of copyrighted material
                    without permission of the copyright owner. Failure to comply
                    shall result in legal action.
                  </div>
                </div>
                <div class="footer-first">
                  <div class="container-fluid">
                    <div class="footer-first">
                      {" "}
                      ITME All Rights Reserved{" "}
                      <i
                        class="fa fa-copyright"
                        aria-hidden="true"
                      ></i> 2023{" "}
                    </div>
                  </div>
                </div>
              </>
            </div>
          </div>
        </>
      </>
    );
  }
}
export default withRouter(
  connect(null, {
    fill_action,
    getAdditionalFurnitureMasterList_action,
    insertUpdateAdditionalFurnitureMaster_action,
    deleteAdditionalFurnitureMaster_action,
    deleteInsertShellScheme_action,
    getShellSchemeList_action,
  })(AdditionalFurnitureMaster)
);
